/* eslint-disable react-hooks/exhaustive-deps */
import { useGoogleLogin } from "@react-oauth/google";
import axios from "axios";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { axiosInstance } from "../utils/axiosInstance";

const GoogleSignIn = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  // const [profile, setProfile] = useState([]);
  const login = useGoogleLogin({
    onSuccess: (codeResponse) => setUser(codeResponse),
    onError: (error) => toast.error("Login Failed:", error),
  });

  const logInWithGoogle = async (profile) => {
    try {
      const formData = new FormData();
      formData.append(`email`, profile?.email);
      formData.append(`full_name`, profile?.name);
      formData.append(`google_accessToken`, user?.access_token);
      formData.append(`google_idToken`, profile?.id);

      const response = await axiosInstance.post("user/google/login", formData);

      if (response.data.status === true) {
        toast.success(response?.data?.message || "Login Successfull");
        localStorage.setItem("token", response?.data?.token);
        localStorage.setItem("user", JSON.stringify(response?.data?.data));
        navigate("/userprofile");
      }
    } catch (error) {
      toast.error(error);
    }
  };

  useEffect(() => {
    if (user) {
      axios
        .get(
          `https://www.googleapis.com/oauth2/v1/userinfo?access_token=${user.access_token}`,
          {
            headers: {
              Authorization: `Bearer ${user.access_token}`,
              Accept: "application/json",
            },
          }
        )
        .then((res) => {
          // setProfile(res.data);
          logInWithGoogle(res.data);
        })
        .catch((err) => toast.error(err));
    }
  }, [user]);

  //   const logOut = () => {
  //     googleLogout();
  //     setProfile(null);
  //   };
  return (
    <button
      onClick={() => login()}
      className="btn btn-light border border-secondary px-4 py-2 d-flex align-items-center gap-2"
    >
      <i className="fab fa-google" style={{ color: "#D54C3F", fontSize: 20 }} />
      <span className="fs-5">Google</span>
    </button>
  );
};

export default GoogleSignIn;
